import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import { IDocumentTypeIndexCategory } from "../../documentTypes/model/DocumentTypeIndexCategory";
import DocumentTypeIndexCategoryMapper from "../../documentTypes/service/DocumentTypeIndexCategoryMapper";
import DocumentTypeIndexCategoryParamMapper from "../../documentTypes/service/DocumentTypeIndexCategoryParamMapper";
import Constants from "../common/Constants";

export default class FindDecisionIndexesInCategoryInteractor {
  private resource: GetAllResourceEntriesInteractor<IDocumentTypeIndexCategory>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(documentTypeId: number, organisationId: number) {
    return this.resource.execute(
      `${Constants.caseDecisionTypesPath}/${documentTypeId}/${Constants.indexCategoriesPath}`,
      DocumentTypeIndexCategoryMapper,
      DocumentTypeIndexCategoryParamMapper,
      {
        params: { organisationId }
      }
    );
  }
}
